import React from 'react';
import {
    withStyles,
    ButtonBase,
} from '@material-ui/core';

import clsx from 'clsx';

class MButton extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { classes, disabled } = this.props;
        return (
            <ButtonBase
                disabled={disabled}
                variant="contained"
                className={disabled ? clsx(classes.root, classes.disabledBtn) : clsx(classes.root, classes.normalBtn)}
                onClick={this.props.onClick}
            >
                {
                    this.props.children
                }
            </ButtonBase>
        );
    }
}

export default withStyles((theme) => ({
    root: {
        borderRadius: 10,
        color: 'white',
        height: 45,
        width: "100%",
        margin: theme.spacing(5, 0, 2, 0),
        fontSize: 16,
        fontWeight: theme.palette.fontWeightBold,
    },
    normalBtn: {
        background: '#007AFF'
    },
    disabledBtn: {
        backgroundColor: '#E2E2E2',
    }
}))(MButton);